import CONFIG from '@/config/config.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import VideoFull from '@/views/process/components/quizInialized/intro/segments/VideoFull.tsx';
import { QuestionSegmentProps } from '@/views/process/components/quizInialized/questions/QuestionSegment.model.ts';
import QuestionWrapper from '@/views/process/components/quizInialized/questions/QuestionWrapper.tsx';
import { isSkippableQuestionSegment } from '@/views/process/components/quizInialized/skipConfig.ts';
import { FC, useState } from 'react';

const audioUrl = 'https://lets-orange.b-cdn.net/lektor-orange-2026/ORANGE_6.mp3';
const animationUrl = 'https://lets-orange.b-cdn.net/animacje/LOQ_S2_A_01.json';

const QuestionSegment5: FC<QuestionSegmentProps> = ({ formComponent }) => {
  const isMobile = useMobileMediaQuery();

  const { t } = useTranslationWithPrefix('views.process.quizQuestions');
  const [videoVisible, setVideoVisible] = useState(true);
  const handleNext = () => {
    setVideoVisible(false);
  };
  if (videoVisible) {
    const videoUrl = isMobile
      ? `${CONFIG.CDN_VIDEO_URL}/002%20-%20Baza%20-%20Outro%20-%209x16.mp4`
      : `${CONFIG.CDN_VIDEO_URL}/002%20-%20Baza%20-%20Outro.mp4`;
    return (
      <VideoFull
        fullWidth
        handleNext={handleNext}
        muted={false}
        showSkip={isSkippableQuestionSegment(5)}
        videoUrl={videoUrl}
      />
    );
  }

  return (
    <QuestionWrapper
      animationUrl={animationUrl}
      audioUrl={audioUrl}
      formComponent={formComponent}
      segmentContent={
        <>
          <p className="lead fw-bold">{t('questions.5.titles.1')}</p>
          <div className="flex flex-column max-w-(--breakpoint-md) gap-s">
            <p className="lead">{t('questions.5.content.1')}</p>
            <p className="lead">{t('questions.5.content.2')}</p>
          </div>
        </>
      }
    />
  );
};

export default QuestionSegment5;
